import React, { useState } from 'react';
import { getProviderConfig } from '../api/integrationConfigs';

const IntegrationConfigDemo = () => {
  const [selectedProvider, setSelectedProvider] = useState('ServiceNow');
  
  const providers = [
    'ServiceNow', 'Jira', 'Zendesk', 'Slack', 'Microsoft Teams', 
    'Datadog', 'New Relic', 'PagerDuty', 'AWS'
  ];
  
  const providerConfig = getProviderConfig(selectedProvider);
  
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Integration Configuration Demo
        </h1>
        <p className="text-gray-600">
          See configuration forms for different integration providers
        </p>
      </div>
      
      {/* Provider Selector */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Select Provider to View Configuration
        </label>
        <select 
          value={selectedProvider}
          onChange={(e) => setSelectedProvider(e.target.value)}
          className="border border-gray-300 rounded-md px-3 py-2 bg-white"
        >
          {providers.map(provider => (
            <option key={provider} value={provider}>{provider}</option>
          ))}
        </select>
      </div>
      
      {/* Configuration Form Preview */}
      {providerConfig && (
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">
            {selectedProvider} Configuration
          </h2>
          
          <div className="space-y-4">
            {providerConfig.fields.map((field) => (
              <div key={field.key}>
                <label className="block text-sm font-medium text-gray-700">
                  {field.label} {field.required && <span className="text-red-500">*</span>}
                </label>
                
                {field.type === 'select' ? (
                  <select
                    className="mt-1 block w-full border border-gray-300 rounded-md px-3 py-2 bg-gray-50"
                    disabled
                  >
                    <option>{field.defaultValue || `Select ${field.label}`}</option>
                    {field.options?.map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </select>
                ) : (
                  <input
                    type={field.type}
                    placeholder={field.placeholder}
                    className="mt-1 block w-full border border-gray-300 rounded-md px-3 py-2 bg-gray-50"
                    disabled
                  />
                )}
                
                {field.description && (
                  <p className="mt-1 text-xs text-gray-500">{field.description}</p>
                )}
              </div>
            ))}
          </div>
          
          {/* Endpoints Information */}
          <div className="mt-6 p-4 bg-gray-50 rounded-md">
            <h3 className="text-sm font-medium text-gray-900 mb-2">Generated Endpoints:</h3>
            <div className="space-y-1 text-xs text-gray-600">
              <div><strong>Base URL:</strong> {providerConfig.endpoints.base_url}</div>
              <div><strong>API Endpoint:</strong> {providerConfig.endpoints.api_endpoint}</div>
              <div><strong>Health Check:</strong> {providerConfig.endpoints.health_check}</div>
            </div>
          </div>
          
          {/* Credentials Information */}
          <div className="mt-4 p-4 bg-blue-50 rounded-md">
            <h3 className="text-sm font-medium text-blue-900 mb-2">Security:</h3>
            <p className="text-xs text-blue-700">
              Credential fields ({providerConfig.credentials_keys.join(', ')}) are encrypted and stored securely.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default IntegrationConfigDemo;